/**
 * @author Francesco Napoletano <fnapoletano@ebay.com>
 */
export default class ClickToToggle {
    /**
     * @param element
     */
    constructor(element) {
        this.element = element;
    }

    /**
     * Toogle content
     * param e jQuery.Event
     */
    toggle(e) {

        let selector = 'click-to-toggle';
        let $trigger = $(e.target);
        let $target = $($trigger.data(selector));
        $target.toggle();
        $('[data-' + selector + ']').toggleClass('toggled');
        if(typeof($trigger.data(selector)) == 'undefined') {
            $('.toggleable:visible').hide();
            $('[data-' + selector + ']').removeClass('toggled');
        }
    }
}
